import ModulesIndex from "../../pages/modules"
import TestSortable from "../../pages/modules/chk"
import RolesIndex from "../../pages/Roles"
import User from "../../pages/User"
import UserManagement from "../../pages/UserManagement"

export const userManagementRoutes = [
  { path: "/user-management", component: <UserManagement /> },
  { path: "/settings-roles", component: <RolesIndex /> },
  { path: "/settings-permission", component: <ModulesIndex /> },
  { path: "/settings-permissionss", component: <TestSortable /> },
  { path: "/settings-permission/:id", component: <ModulesIndex /> },
  { path: "/settings-users", component: <User /> },
]
